module.exports = __webpack_public_path__ + "img/mysql.b04e488e.svg";